import React from 'react';
import { Box } from '@mui/material';
import DocSidebar from './DocSidebar';
import { useLocation } from 'react-router-dom';

const DocumentationLayout = ({ children }) => {
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Sidebar stays on all /documentation routes */}
      <Box sx={{ width: '250px', position: 'sticky', top: 0, height: '100vh', bgcolor: 'background.paper', borderRight: '1px solid #e0e0e0' }}>
        <DocSidebar />
      </Box>

      {/* Main Content scrolls independently */}
      <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 4 }}>
        {children}
      </Box>
    </Box>
  );
};

export default DocumentationLayout;
